import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {ReportLinkDto} from '../../types'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

export const useReportLinks = (
  reportId: string,
  options?: Omit<UseQueryOptions<ReportLinkDto[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<ReportLinkDto[], AxiosError>({
    queryKey: riskSurveyQueryKeys.reports.links(reportId),
    queryFn: ({signal}) => riskSurveyQueries.getReportLinks(reportId, signal),
    enabled: !!reportId,
    staleTime: 30_000,
    gcTime: 300_000,
    ...options
  })
}
